"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Html", {
  enumerable: true,
  get: function get() {
    return _html["default"];
  }
});
exports.getNewContent = exports["default"] = void 0;
Object.defineProperty(exports, "toHtml", {
  enumerable: true,
  get: function get() {
    return _toHtml["default"];
  }
});
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdLoadGlobalLibrary = _interopRequireDefault(require("cccisd-load-global-library"));
var _forEach2 = _interopRequireDefault(require("lodash/forEach"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _keys2 = _interopRequireDefault(require("lodash/keys"));
var _difference2 = _interopRequireDefault(require("lodash/difference"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _update2 = _interopRequireDefault(require("lodash/update"));
var _uuid = _interopRequireDefault(require("./uuid.js"));
var _Audio = _interopRequireDefault(require("./plugins/Audio"));
var _ResourceImage = _interopRequireDefault(require("./plugins/ResourceImage"));
var _Variables = _interopRequireDefault(require("./plugins/Variables"));
var _WordTimings = _interopRequireDefault(require("./plugins/WordTimings"));
var _Tooltip = _interopRequireDefault(require("./plugins/Tooltip"));
var _Information = _interopRequireDefault(require("./plugins/Information"));
var _Icons = _interopRequireDefault(require("./plugins/Icons"));
var _Background = _interopRequireDefault(require("./plugins/Background"));
var _ImageStyle = _interopRequireDefault(require("./plugins/ImageStyle"));
var _style = _interopRequireDefault(require("./style.css"));
var _editor = _interopRequireDefault(require("./editor.js"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _classnames = _interopRequireDefault(require("classnames"));
var _html = _interopRequireDefault(require("./html.js"));
var _toHtml = _interopRequireDefault(require("./toHtml.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable func-names, space-before-function-paren */
(0, _update2["default"])(window, 'cccisd.temp.wysiwyg', function (n) {
  return n || {};
});
var config = (0, _get2["default"])(window, 'cccisd.temp.wysiwyg');
/** WYSIWYG editor based on TINYMCE */
var Wysiwyg = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Wysiwyg(props, context) {
    var _this;
    _classCallCheck(this, Wysiwyg);
    _this = _callSuper(this, Wysiwyg, [props]);
    _defineProperty(_this, "componentDidMount", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var settings, validOptions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this._mountTinymce();
          case 2:
            _context.next = 4;
            return _this._mountToolbarWrapper();
          case 4:
            settings = _this._getEditorSettings();
            _context.next = 7;
            return window.tinymce.init(settings);
          case 7:
            validOptions = ['start', 'end', 'select-all'];
            if (validOptions.includes(_this.props.autofocus) && !config.isAutofocused) {
              // Give Tinymce some time to setup editor
              setTimeout(function () {
                // focus on this instance of TinyMCE
                document.querySelector('#' + _this.id).focus();

                // We need to autofocus only one tinymce at time
                // We're saving autofocus state in a global array
                // And resetting it after a while
                config.isAutofocused = true;
                setTimeout(function () {
                  config.isAutofocused = false;
                }, 100);
                if (_this.props.selectAllOnFocus || _this.props.autofocus === 'start') {
                  return;
                }
                var s = window.getSelection();
                var r = s.getRangeAt(0);

                // select all
                r.setStart(s.focusNode, 0);
                r.setEnd(s.focusNode, s.focusNode.length);
                s.addRange(r);
                if (_this.props.autofocus === 'select-all') {
                  return;
                }

                // collspase selection to just the end
                // this effectively moves the cursor to the end
                s.collapseToEnd();
              }, 100);
            }
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "componentWillUnmount", function () {
      clearInterval(_this.intervalId);
      clearTimeout(_this.timeoutId);
      if (window.tinymce) {
        window.tinymce.EditorManager.execCommand('mceRemoveEditor', true, _this.id);
      }
    });
    _defineProperty(_this, "_onChange", function (text, meta) {
      // We have to save variables because user can remove variable and then undo the change
      // In this case we will restore variable from here
      _this.variables = _objectSpread(_objectSpread({}, _this.variables), meta && meta.variables || {});

      // ditto on images
      _this.images = _objectSpread(_objectSpread({}, _this.images), meta && meta.images || {});

      // ditto on tooltips
      _this.tooltips = _objectSpread(_objectSpread({}, _this.tooltips), meta && meta.tooltips || {});
      _this.content = getNewContent(text, meta, _this.variables, _this.images, _this.tooltips);
      _this.props.onChange(_this.content);
    });
    _defineProperty(_this, "_mountTinymce", function () {
      return (0, _cccisdLoadGlobalLibrary["default"])('tinymce', '//dm0gz550769cd.cloudfront.net/core_assets/tinymce_4.6.7/tinymce.full.min.js');
    });
    _defineProperty(_this, "_mountToolbarWrapper", function () {
      return new Promise(function (resolve, reject) {
        if (!document.querySelector('#' + _this.wrapperId)) {
          var div = document.createElement('div');
          div.setAttribute('id', _this.wrapperId);
          div.setAttribute('style', 'position: fixed; top: 0; right: 0; z-index: 1500');
          document.body.appendChild(div);
        }
        resolve();
      });
    });
    _defineProperty(_this, "_mountStylesheet", function (href) {
      if (!document.querySelector("head link[href=\"".concat(href, "\"]"))) {
        var link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('href', href);
        document.head.appendChild(link);
      }
    });
    _defineProperty(_this, "_getIcons", function () {
      var icons = [];
      _this.plugins.forEach(function (plugin) {
        if (plugin.addIcon) {
          var icon = plugin.addIcon(_this.content);
          if (icon) {
            if (!(0, _isArray2["default"])(icon)) {
              icon = [icon];
            }
            icons = [].concat(_toConsumableArray(icons), _toConsumableArray(icon));
          }
        }
      });
      if (icons.length === 0) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].iconWrapper, _this.state.focused && _style["default"].focused)
      }, icons.reverse().map(function (icon, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].icon,
          key: index
        }, icon);
      }));
    });
    _defineProperty(_this, "_getEditorSettings", function () {
      var $this = _this;
      var settings = {};
      switch (_this.props.type) {
        case 'textarea':
          {
            break;
          }
        case 'textarea-inline':
          {
            settings = {
              inline: true,
              fixed_toolbar_container: '#' + _this.wrapperId
            };
            break;
          }
        case 'input':
          {
            settings = {
              inline: true,
              fixed_toolbar_container: '#' + _this.wrapperId,
              forced_root_block: false,
              menubar: false,
              toolbar: ['styleselect bold italic underline | forecolor backcolor | code | cccisdAudio cccisdWordTimings cccisdImageResource cccisdImageStyle cccisdBackground cccisdVariables | cccisdTooltip cccisdInformation cccisdIcons']
            };
            break;
          }
        default:
          {
            if (_this.props.type && _this.props.type !== '') {
              console.error("There is no \"".concat(_this.props.type, "\" type for WYSIWYG-editor"));
            } else {
              console.error('You should provide type prop for WYSIWYG-editor');
            }
            break;
          }
      }
      return _objectSpread(_objectSpread({
        selector: '#' + _this.id,
        plugins: ['charmap lists link hr code table paste textcolor noneditable'],
        menubar: 'edit insert format table tools',
        toolbar: ['bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor | hr charmap', 'formatselect styleselect | link unlink | table | code | cccisdAudio cccisdWordTimings cccisdImageResource cccisdImageStyle cccisdBackground cccisdVariables | cccisdTooltip cccisdInformation cccisdIcons'],
        extended_valid_elements: 'svg[*],g[*],path[*]',
        hidden_input: false,
        browser_spellcheck: true,
        relative_urls: false,
        block_formats: 'Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3;Preformatted=pre',
        style_formats: [{
          title: 'Small',
          inline: 'span',
          styles: {
            fontSize: '0.8em'
          }
        }, {
          title: 'Normal',
          inline: 'span',
          styles: {
            fontSize: '1em'
          }
        }, {
          title: 'Large',
          inline: 'span',
          styles: {
            fontSize: '1.2em'
          }
        }, {
          title: 'Huge',
          inline: 'span',
          styles: {
            fontSize: '1.4em'
          }
        }, {
          title: 'Enormous',
          inline: 'span',
          styles: {
            fontSize: '1.6em'
          }
        }],
        table_default_attributes: {
          "class": 'table table-bordered'
        },
        table_default_styles: {
          width: '100%'
        },
        table_class_list: [{
          title: 'None',
          value: "table ".concat(_style["default"].borderless)
        }, {
          title: 'Bordered',
          value: 'table table-bordered'
        }, {
          title: 'Striped',
          value: 'table table-bordered table-striped'
        }],
        table_row_class_list: [{
          title: 'None',
          value: ''
        }, {
          title: 'Active',
          value: 'active'
        }, {
          title: 'Success',
          value: 'success'
        }, {
          title: 'Warning',
          value: 'warning'
        }, {
          title: 'Danger',
          value: 'danger'
        }, {
          title: 'Info',
          value: 'info'
        }],
        table_cell_class_list: [{
          title: 'None',
          value: ''
        }, {
          title: 'Active',
          value: 'active'
        }, {
          title: 'Success',
          value: 'success'
        }, {
          title: 'Warning',
          value: 'warning'
        }, {
          title: 'Danger',
          value: 'danger'
        }, {
          title: 'Info',
          value: 'info'
        }],
        table_responsive_width: true,
        paste_webkit_styles: 'color font-size',
        init_instance_callback: function init_instance_callback(editor) {
          editor.on('Change KeyPress KeyUp Undo Redo', function (e) {
            var content = editor.getContent();

            // remove "height" from images as it affects aspect ratio when image is updated
            if (/<img[^>]*height="[^"]+"[^>]*>/.test(content)) {
              content = content.replace(/<img[^>]+>/g, function (str) {
                return str.replace(/height="[^"]+"/g, '');
              });
              editor.setContent(content);
            }
            $this._onChange(content, $this.content.meta);
          });
          editor.on('Blur', function (e) {
            $this.props.onBlur(editor.getContent());
            if ($this.state.focused) {
              $this.setState({
                focused: false
              });
            }
          });
          editor.on('Focus', function (e) {
            if ($this.props.selectAllOnFocus) {
              editor.execCommand('selectAll');
            }
            if (!$this.state.focused) {
              $this.setState({
                focused: true
              });
            }
          });
        },
        setup: function setup(editor) {
          (0, _forEach2["default"])($this.plugins, function (plugin) {
            editor.addButton(plugin.name, _objectSpread(_objectSpread(_objectSpread({}, plugin.icon && {
              icon: plugin.icon
            }), plugin.image && {
              image: plugin.image
            }), {}, {
              text: plugin.text,
              tooltip: plugin.tooltip,
              onPostRender: function onPostRender() {
                var ctrl = this;
                if (plugin.activeCondition) {
                  editor.on('NodeChange', function (e) {
                    ctrl.active(plugin.activeCondition(e.element, $this.content.meta));
                  });
                }
                if (plugin.disableCondition) {
                  editor.on('NodeChange', function (e) {
                    ctrl.disabled(plugin.disableCondition(editor.getContent(), $this.content.meta, e.element, editor.selection.getContent()));
                  });
                }
              },
              onclick: function onclick() {
                var bookmark = editor.selection.getBookmark();
                var insertContent = function insertContent(text) {
                  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $this.content.meta;
                  $this.refs.modal.close();
                  editor.focus();
                  editor.selection.moveToBookmark(bookmark);
                  editor.insertContent(text);

                  // Update text in redux
                  var wholeText = editor.getContent();
                  $this._onChange(wholeText, meta);
                };
                var setContent = function setContent(text) {
                  var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $this.content.meta;
                  $this.refs.modal.close();
                  editor.focus();
                  editor.selection.moveToBookmark(bookmark);
                  editor.setContent(text);

                  // Update text in redux
                  $this._onChange(text, meta);
                };
                var Component = plugin.component;
                $this.setState({
                  popupContent: /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
                    fallback: /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
                      loading: true
                    })
                  }, /*#__PURE__*/_react["default"].createElement(Component, {
                    content: editor.getContent(),
                    meta: $this.content.meta || {},
                    selectedContent: editor.selection.getContent(),
                    insertContent: insertContent,
                    setContent: setContent
                  })),
                  popupTitle: plugin.title,
                  popupSize: plugin.modalSize || 'normal'
                }, function () {
                  $this.refs.modal.open();
                });
              }
            }));
          });
        }
      }, settings), _this.props.settings);
    });
    _defineProperty(_this, "render", function () {
      var content = _this.props.content;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].editorWrapper
      }, _this._getIcons(), /*#__PURE__*/_react["default"].createElement(_editor["default"], {
        id: _this.id,
        content: (0, _isString2["default"])(content) ? content : (content === null || content === void 0 ? void 0 : content.content) || '',
        inputStyle: _this.props.inputStyle
      }), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: _this.state.popupTitle,
        trigger: null,
        ref: "modal",
        size: _this.state.popupSize
      }, _this.state.popupContent));
    });
    _this.id = (0, _uuid["default"])();
    _this.intervalId = null;
    _this.timeoutId = null;
    _this.checkInterval = 50;
    _this.checkTimeout = 5000;
    _this.wrapperId = 'cccisd-tinymce-wrapper';
    _this.content = props.content || '';
    _this.variables = {};
    _this.images = {};
    _this.tooltips = {};
    _this.plugins = [_Audio["default"], _ResourceImage["default"], _WordTimings["default"], _Tooltip["default"], _Information["default"], _Icons["default"], _Background["default"], _ImageStyle["default"]];
    if (context.flow) {
      _this.plugins.push(_Variables["default"]);
    }
    _this.state = {
      popupContent: null,
      popupTitle: 'Plugin settings',
      popupSize: 'normal',
      focused: false
    };
    return _this;
  }
  _inherits(Wysiwyg, _React$Component);
  return _createClass(Wysiwyg);
}(_react["default"].Component);
_defineProperty(Wysiwyg, "propTypes", {
  /** Initial content of the editor. */
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  /** The type of Editor. <br> <i>I.e.</i>: 'textarea', 'textarea-inline', and 'input' */
  type: _propTypes["default"].string,
  /** Used to override TinyMCE settings. */
  settings: _propTypes["default"].object,
  /** Whether to auto focus on an input field once the Editor mounts. <br> Options: 'start', 'end', and 'select-all' */
  autofocus: _propTypes["default"].string,
  /** Callback function that runs when the Editor's content is changed. */
  onChange: _propTypes["default"].func,
  /** Callback function that runs when an input field loses focus. */
  onBlur: _propTypes["default"].func,
  /** Custom style for input area */
  inputStyle: _propTypes["default"].object,
  /** Selects all text on focus when true. */
  selectAllOnFocus: _propTypes["default"].bool
});
_defineProperty(Wysiwyg, "defaultProps", {
  content: '',
  type: 'textarea-inline',
  settings: {},
  autofocus: null,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  inputStyle: {},
  selectAllOnFocus: false
});
_defineProperty(Wysiwyg, "contextTypes", {
  flow: _propTypes["default"].object
});
var getNewContent = exports.getNewContent = function getNewContent(text, meta, savedVariables, savedImages, savedTooltips) {
  var newContent = {
    content: text,
    meta: meta
  };
  function getContentVariables(content) {
    var regex = /data-variable="([^"]*)"/g;
    var vars = [];
    var result;
    // eslint-disable-next-line no-cond-assign
    while (result = regex.exec(newContent.content)) {
      vars.push(result[1]);
    }
    return vars;
  }
  function getContentImages(content) {
    var regex = /data-image="([^"]*)"/g;
    var images = [];
    var result;
    // eslint-disable-next-line no-cond-assign
    while (result = regex.exec(newContent.content)) {
      images.push(result[1]);
    }
    return images;
  }
  function getContentTooltips(content) {
    var regex = /data-tooltip="([^"]*)"/g;
    var vars = [];
    var result;
    // eslint-disable-next-line no-cond-assign
    while (result = regex.exec(newContent.content)) {
      vars.push(result[1]);
    }
    return vars;
  }
  var contentVariables = getContentVariables(newContent.content);
  var contentImages = getContentImages(newContent.content);
  var contentTooltips = getContentTooltips(newContent.content);

  // Restore variable from buffer if user did an undo
  if (contentVariables.length > 0) {
    var metaVariables = newContent.meta && newContent.meta.variables || {};
    var missedVariables = (0, _difference2["default"])(contentVariables, (0, _keys2["default"])(metaVariables));
    (0, _set2["default"])(newContent, 'meta.variables', _objectSpread(_objectSpread({}, metaVariables), (0, _pick2["default"])(savedVariables, missedVariables)));
  }

  // Remove variables from meta if they have been removed from text
  if (newContent.meta && newContent.meta.variables) {
    newContent.meta.variables = (0, _pick2["default"])(newContent.meta.variables, contentVariables);
    if ((0, _isEqual2["default"])(newContent.meta.variables, {})) {
      newContent.meta = (0, _omit2["default"])(newContent.meta, 'variables');
    }
  }

  // ------

  // Restore image from buffer if user did an undo
  if (contentImages.length > 0) {
    var metaImages = newContent.meta && newContent.meta.images || {};
    var missedImages = (0, _difference2["default"])(contentImages, (0, _keys2["default"])(metaImages));
    (0, _set2["default"])(newContent, 'meta.images', _objectSpread(_objectSpread({}, metaImages), (0, _pick2["default"])(savedImages, missedImages)));
  }

  // Remove image from meta if they have been removed from text
  if (newContent.meta && newContent.meta.images) {
    newContent.meta.images = (0, _pick2["default"])(newContent.meta.images, contentImages);
    if ((0, _isEqual2["default"])(newContent.meta.images, {})) {
      newContent.meta = (0, _omit2["default"])(newContent.meta, 'images');
    }
  }

  // ------

  // Restore tooltip from buffer if user did an undo
  if (contentTooltips.length > 0) {
    var metaTooltips = newContent.meta && newContent.meta.tooltips || {};
    var missedTooltips = (0, _difference2["default"])(contentTooltips, (0, _keys2["default"])(metaTooltips));
    (0, _set2["default"])(newContent, 'meta.tooltips', _objectSpread(_objectSpread({}, metaTooltips), (0, _pick2["default"])(savedTooltips, missedTooltips)));
  }

  // Remove tooltips from meta if they have been removed from text
  if (newContent.meta && newContent.meta.tooltips) {
    newContent.meta.tooltips = (0, _pick2["default"])(newContent.meta.tooltips, contentTooltips);
    if ((0, _isEqual2["default"])(newContent.meta.tooltips, {})) {
      newContent.meta = (0, _omit2["default"])(newContent.meta, 'tooltips');
    }
  }

  // ------

  // Return result as a string if meta is an empty object
  if (!newContent.meta || (0, _isEqual2["default"])(newContent.meta, {})) {
    newContent = newContent.content;
  }
  return newContent;
};